<template>
<html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link rel="icon" href="img/favicon.ico">
  <link rel="stylesheet" href="theme.css" type="text/css">
  <title>Porto - Portal de Autonegociação</title>
</head>

<body>
  <div class="validate-token-wrapper">
    <div class="validate-token-card">
      <div class="validate-token-body">
        <div class="validate-token-icon">
          <svg v-if="typesent === 'email'" width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6.5C3 5.67157 3.67157 5 4.5 5H19.5C20.3284 5 21 5.67157 21 6.5V17.5C21 18.3284 20.3284 19 19.5 19H4.5C3.67157 19 3 18.3284 3 17.5V6.5Z" stroke="white" stroke-width="1.6" stroke-linejoin="round"/>
            <path d="M3.5 6.5L12 13L20.5 6.5" stroke="white" stroke-width="1.6" stroke-linejoin="round"/>
          </svg>
          <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z" fill="white"/>
          </svg>
        </div>

        <h5 class="validate-token-title">Valide seu token</h5>
        <p class="validate-token-subtitle">
          Enviamos um código de 6 dígitos para o seu {{ typesent === 'email' ? 'e-mail' : 'telefone' }}
        </p>

        <form v-on:submit="login" v-on:submit.prevent>
          <div class="token-digits">
            <input
              v-for="(digit, index) in codeDigits"
              :key="index"
              :ref="'codeBox'"
              type="text"
              maxlength="1"
              autocomplete="one-time-code"
              class="token-digit"
              :class="{ filled: !!codeDigits[index] }"
              :value="codeDigits[index]"
              :disabled="loading"
              @input="onDigitInput(index, $event)"
              @keydown="onDigitKeydown(index, $event)"
              @paste="onDigitPaste($event)"
            />
          </div>

          <p v-if="countdownLabel" class="token-countdown">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>
              <path d="M12 7V12L15.5 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            </svg>
            <span v-if="!isExpired">Expira em <strong>{{ countdownLabel }}</strong></span>
            <span v-else class="text-danger">Código expirado — solicite um novo</span>
          </p>

          <button
            type="submit"
            id="confirm"
            :disabled="loading || isExpired || assembledCode.length < 6"
            class="btn-validate"
          >
            Validar e Entrar
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M5 12.5L10 17.5L19 7.5" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </form>

        <div v-if="loading" class="token-loading">
          <ProgressLoading v-bind:loading="loading" />
        </div>

        <hr class="token-divider" />

        <p class="token-other-contact">
          <a @click.prevent="naoRecebiCodigo" class="token-other-contact-link" href="#">Não recebi o código</a>
        </p>
      </div>
    </div>
  </div>
</body>

</html>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ProgressLoading from './ProgressLoading.vue';
import { initializeGlobals } from '@/global';

export default {
    name: 'codigo-enviado',
    components: {
        ProgressLoading
    },
    data: () => ({
        form: {
            promocode: null
        },
        codeDigits: ['', '', '', '', '', ''],
        loading: false,
        largura: null,
        userDataStorage: {},
        pageLocation: null,
        url: null,
        protocol: null,
        path: null,
        host: null,
        ipUser: null,
        typesent: null,
        promoCodeExpiresAt: null,
        remainingSeconds: null,
        countdownTimer: null,
        expirationRedirectTimer: null,
    }),

    async created() {
      this.updateCustomData();
      this.ipUser = localStorage.getItem('ipUser');
      localStorage.setItem("currentPageName", this.$options.name);
      this.largura = window.screen.width;
      this.protocol = window.location.protocol;
      this.host = window.location.host;
      this.userDataStorage = JSON.parse(localStorage.getItem("userData"));
      this.pageLocation = this.userDataStorage.page_location;
      this.buildAndSetUserData(this.userDataStorage.cpfCnpj, this.userDataStorage.id, this.pageLocation, 'codigo-enviado');
      this.$emit('updatePageView', this.pageLocation);
    },

    // FormLogin.vue mantém todos os estados dentro de <keep-alive>. activated() dispara
    // toda vez que esta tela fica ativa — inclusive na primeira montagem (roda logo após
    // created()/mounted()) — então basta um único lugar pra ler typesent/promoCodeExpiresAt
    // e focar a primeira caixinha.
    //
    // Isso importa porque, sem ele, se o usuário sai desta tela (ex.: "Voltar") e o fluxo
    // chega aqui de novo depois (código reenviado), o Vue REAPROVEITA esta mesma instância
    // em vez de recriá-la — sem um hook que rode a cada ativação, a tela reapareceria
    // travada no countdown/typesent da primeira vez, podendo mostrar "expirado" na hora
    // mesmo com um código novo.
    activated() {
      this.refreshCodeState();
      this.focusBox(0);
    },

    deactivated() {
      this.clearTimers();
    },

    beforeDestroy() {
      this.clearTimers();
    },

    watch: {
      // Dispara só na transição false -> true (uma vez por expiração real), não a cada
      // tick do contador. refreshCodeState() zera promoCodeExpiresAt/remainingSeconds a
      // cada ativação da tela, então um código novo não reabre este watch por engano.
      isExpired(expired) {
        if (expired) {
          this.scheduleExpirationRedirect();
        }
      },
    },

    computed: {
        ...mapState('auth', ['contacts']),

        assembledCode() {
          return this.codeDigits.join('');
        },

        isExpired() {
          return this.promoCodeExpiresAt !== null && this.remainingSeconds !== null && this.remainingSeconds <= 0;
        },

        countdownLabel() {
          if (this.promoCodeExpiresAt === null || this.remainingSeconds === null) return null;
          const clamped = Math.max(0, this.remainingSeconds);
          const minutes = Math.floor(clamped / 60);
          const seconds = clamped % 60;
          return `${minutes}:${String(seconds).padStart(2, '0')}`;
        },
    },
    methods: {
        ...mapActions('auth', ['ActionDoLogin', 'ActionSetCurrentForm']),

        clearTimers() {
          if (this.countdownTimer) {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
          }
          if (this.expirationRedirectTimer) {
            clearTimeout(this.expirationRedirectTimer);
            this.expirationRedirectTimer = null;
          }
        },

        refreshCodeState() {
          this.codeDigits = ['', '', '', '', '', ''];
          this.typesent = localStorage.getItem('typesent');
          this.startCountdown(localStorage.getItem('promoCodeExpiresAt'));
        },

        startCountdown(expiresAtIso) {
          this.clearTimers();

          if (!expiresAtIso) {
            this.promoCodeExpiresAt = null;
            this.remainingSeconds = null;
            return;
          }

          const expiresAtMs = new Date(expiresAtIso).getTime();
          if (Number.isNaN(expiresAtMs)) {
            this.promoCodeExpiresAt = null;
            this.remainingSeconds = null;
            return;
          }

          this.promoCodeExpiresAt = expiresAtIso;

          const tick = () => {
            this.remainingSeconds = Math.round((expiresAtMs - Date.now()) / 1000);
          };
          tick();
          this.countdownTimer = setInterval(tick, 1000);
        },

        onDigitInput(index, event) {
          const raw = event.target.value || '';
          // Aceita letra ou número; cola/autofill de vários chars usa o último caractere.
          const single = raw.slice(-1);
          event.target.value = single;
          this.$set(this.codeDigits, index, single);

          if (single && index < this.codeDigits.length - 1) {
            this.focusBox(index + 1);
          }
        },

        onDigitKeydown(index, event) {
          if (event.key === 'Backspace' && !this.codeDigits[index] && index > 0) {
            this.focusBox(index - 1);
          }
        },

        onDigitPaste(event) {
          const pasted = (event.clipboardData || window.clipboardData).getData('text').trim();
          if (!pasted) return;
          event.preventDefault();

          const chars = pasted.replace(/\s/g, '').slice(0, this.codeDigits.length).split('');
          chars.forEach((char, i) => this.$set(this.codeDigits, i, char));

          const lastIndex = Math.min(chars.length, this.codeDigits.length) - 1;
          if (lastIndex >= 0) this.focusBox(lastIndex);
        },

        focusBox(index) {
          this.$nextTick(() => {
            const box = this.$refs.codeBox && this.$refs.codeBox[index];
            if (box) box.focus();
          });
        },

        async login() {
          this.eventConfirmCodeGTM();

          if (this.assembledCode.length < 6) {
              this.flashMessage.show({
                    timeout:300,
                    status: 'error',
                    position:'top right',
                    title: 'Erro',
                    message: 'Informe o código de acesso completo'});
                this.loading = false;
                return;
            }

            this.loading = true;
            let debtorId = this.contacts.DebtorID;
            let promoCode = this.assembledCode;

            try {
                await this.ActionDoLogin({
                    DebtorID: debtorId,
                    PromoCode: promoCode,
                    device_name: process.env.VUE_APP_API_DEVICE,
                    IP: this.ipUser ? this.ipUser : '',
                    OS:navigator.platform
                })
                this.loading =  false;
                this.eventCallbackConfirmSuccessGTM();
                this.buildAndSetUserData(this.userDataStorage.cpfCnpj, this.userDataStorage.id, this.protocol + '//' + this.host + '/dashboard', 'Dashboard');

               this.$router.push({ name: 'dashboard' });
            } catch (error) {
                this.flashMessage.show({
                    timeout:300,
                    status: 'error',
                    position:'top right',
                    title: 'Erro',
                    message: 'CPF/CNPJ ou código de acesso incorretos'});
                this.loading = false;

                this.eventCallbackConfirmFailureGTM(error);

                return;
            }

        },

        voltar() {
            this.eventsendAgainCodeGTM();
            this.goToInitialLogin();
        },

        naoRecebiCodigo() {
            this.eventNaoRecebiCodigoGTM();
            this.clearTimers();
            localStorage.removeItem('promoCodeExpiresAt');
            localStorage.setItem('reopenChannelSelect', '1');
            this.buildAndSetUserData(
              this.userDataStorage.cpfCnpj,
              this.userDataStorage.id,
              this.protocol + '//' + this.host + '/dashboard',
              'form-doc-number'
            );
            this.updateCustomData();
            this.ActionSetCurrentForm('form-doc-number');
        },

        // Dá um tempo pro usuário ler "Código expirado" antes de tirá-lo da tela — sair na
        // hora, sem aviso, pareceria a página travando/quebrando.
        scheduleExpirationRedirect() {
          if (this.expirationRedirectTimer) return;

          this.eventCodeExpiredRedirectGTM();
          this.expirationRedirectTimer = setTimeout(() => {
            this.expirationRedirectTimer = null;
            this.goToInitialLogin();
          }, 2500);
        },

        goToInitialLogin() {
            this.clearTimers();
            // Código desta sessão não serve mais pra nada — limpa pra não vazar pra
            // próxima tentativa de login (ex.: countdown de um código já expirado).
            localStorage.removeItem('promoCodeExpiresAt');
            localStorage.removeItem('typesent');
            this.buildAndSetUserData(
              this.userDataStorage.cpfCnpj,
              this.userDataStorage.id,
              this.protocol + '//' + this.host + '/dashboard',
              'form-doc-number'
            );
            this.updateCustomData();
            this.ActionSetCurrentForm("form-doc-number");
        },

        buildAndSetUserData(doc, id, pageLocation, pageName) {
          const userData = {
                          cpfCnpj: doc, // Substitua pelo CPF/CNPJ real
                          id: id, // Substitua pelo ID real
                          page_location: pageLocation,
                          pageName: pageName
                        };
                        localStorage.setItem("userData", JSON.stringify(userData));
        },

        eventsendAgainCodeGTM() {
          const pageName = this.$options.name;
          const eventCategory = `portal-de-negociacao:porto:${pageName}`;
          const eventAction = 'click:link:voltar';

          const eventData = {
            event: 'select_content',
            ev_category: eventCategory,
            ev_action: eventAction,
            ev_label: '',
          };

          window.dataLayer.push({ event: 'select_content', ...eventData });
        },

        eventNaoRecebiCodigoGTM() {
          const pageName = this.$options.name;
          const eventCategory = `portal-de-negociacao:porto:${pageName}`;
          const eventAction = 'click:link:nao-recebi-codigo';

          const eventData = {
            event: 'select_content',
            ev_category: eventCategory,
            ev_action: eventAction,
            ev_label: '',
          };

          window.dataLayer.push({ event: 'select_content', ...eventData });
        },

        eventCodeExpiredRedirectGTM() {
          const pageName = this.$options.name;
          const eventCategory = `portal-de-negociacao:porto:${pageName}`;
          const eventAction = 'redirect:auto:codigo-expirado';

          const eventData = {
            event: 'select_content',
            ev_category: eventCategory,
            ev_action: eventAction,
            ev_label: '',
          };

          window.dataLayer.push({ event: 'select_content', ...eventData });
        },

        eventConfirmCodeGTM() {

          const pageName = this.$options.name;
          const eventCategory = `portal-de-negociacao:porto:${pageName}`;
          const eventAction = 'click:button:confirmar';

          const eventData = {
            event: 'select_content',
            ev_category: eventCategory,
            ev_action: eventAction,
            ev_label: '',
          };

          window.dataLayer.push({ event: 'select_content', ...eventData });

        },

        eventCallbackConfirmSuccessGTM() {
          const typesent = localStorage.getItem("typesent");
          const pageName = this.$options.name;
          const eventCategory = `portal-de-negociacao:porto:${pageName}`;
          const eventAction =`token:${typesent}:sucesso`;

          const eventData = {
            event: 'token',
            ev_category: eventCategory,
            ev_action: eventAction,
            ev_label: 'validado',
          };

          window.dataLayer.push({ event: 'token', ...eventData });
        },

        eventCallbackConfirmFailureGTM(error) {
                    const pageName = this.$options.name;
                    const eventCategory = `portal-de-negociacao:porto:${pageName}`;
                    const eventAction = 'confirmar-codigo-de-acesso:alert';
                    const eventLabel = error?.data?.message;
                    const eventCode = error?.status;
                    const eventErrorService = '';
                    const eventAlertService = error?.data?.message;
                    const eventAlert = 'token';
                    const eventAlertType = 'erro';
                    const eventData = {
                      event: 'alert',
                      ev_category: eventCategory,
                      ev_action: eventAction,
                      ev_label: eventLabel,
                      alert_code: eventCode,
                      error_service: eventErrorService,
                      alert_service_message: eventAlertService,
                      alert_event: eventAlert,
                      alert_type: eventAlertType,
                    };

                    window.dataLayer.push({ event: 'alert', ...eventData });
    },

    updateCustomData() {
      const globals = initializeGlobals();
      window.customData = globals.customData;
    }

    },
}
</script>
<style scoped>
.validate-token-wrapper {
  min-height: 100vh;
  background-color: #0046C0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.validate-token-card {
  max-width: 420px;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.validate-token-body {
  padding: 2rem 1.5rem 1.75rem;
  text-align: center;
}

.validate-token-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background-color: #0046C0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

.validate-token-title {
  margin: 0 0 0.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.validate-token-subtitle {
  margin: 0 auto;
  max-width: 280px;
  font-size: 0.9rem;
  line-height: 1.4;
  color: #6c757d;
}

.token-digits {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 1.25rem 0 0.75rem;
  width: 100%;
}

.token-digit {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1.5px solid #ced4da;
  border-radius: 50%;
  background: #fff;
  text-align: center;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1;
  color: #0046C0;
  outline: none;
  box-shadow: none;
  -moz-appearance: textfield;
}

.token-digit::-webkit-outer-spin-button,
.token-digit::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.token-digit:focus {
  border-color: #0046C0;
  box-shadow: 0 0 0 2px rgba(0, 70, 192, 0.15);
}

.token-digit.filled {
  border-color: #0046C0;
}

.token-digit:disabled {
  opacity: 0.6;
  background: #f8f9fa;
}

.token-countdown {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0 0 1.25rem;
  font-size: 0.85rem;
  color: #6c757d;
}

.token-countdown strong {
  font-weight: 700;
  color: #495057;
}

.btn-validate {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  padding: 0.75rem 1.25rem;
  border: none;
  border-radius: 999px;
  background-color: #0046C0;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease, background-color 0.15s ease;
}

.btn-validate:hover:not(:disabled) {
  background-color: #0039a0;
}

.btn-validate:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.token-loading {
  margin-top: 0.75rem;
}

.token-divider {
  margin: 1.25rem 0 1rem;
  border: 0;
  border-top: 1px solid #e9ecef;
}

.token-other-contact {
  margin: 0;
  font-size: 0.9rem;
}

.token-other-contact-link {
  color: #0046C0;
  text-decoration: none;
  font-weight: 500;
}

@media (max-width: 420px) {
  .validate-token-body {
    padding: 1.5rem 1rem 1.5rem;
  }

  .token-digits {
    gap: 4px;
  }

  .token-digit {
    width: 34px;
    height: 34px;
    font-size: 0.95rem;
  }
}
</style>
